import WithRender from "../../templates/buttons/loginButton.html";
import axios from "../../axios-auth";
import { mapGetters, mapActions } from "vuex";
import { i18n } from "../../i18n.js";
import * as R from "ramda";

export default WithRender({
  computed: {
    ...mapGetters([
      "getShowLoginPopupCallback",
      "getIsLogin",
      "getIsMobile",
      "getIsSummaryFooterExpanded",
      "getCustomer",
      "getBaseUrl"
    ]),
    getDisableClass: function () {
      return "";
    }
  },
  methods: {
    ...mapActions(["setShowCustomizationPopup", "setSelectionToLocalStorage"]),
    onClickLogin: function (event) {
      this.setSelectionToLocalStorage({ isLoadedFromSavedList: false });
      if (!this.getIsLogin) {
        this.getShowLoginPopupCallback(event);
      } else {
        this.setShowCustomizationPopup(true);
        jQuery("body").addClass("printq_product_customization_popup_open");
      }
    }
  }
});
